import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const mavenConfig: TSPConfig = {
  key: 'maven',
  name: 'Maven',
  category: TSPCategory.API_KEY,
  helpText: 'Please request an API key from your Maven representative.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default mavenConfig;
